import { parseDataForEditor } from 'scripts/helpers/util.js';

// whether we are already fetching reviews for the homepage
let fetching = false;
// info for the fetching of the data
const apiKey = 'aOHeB8HyNCp6L6AWQwoCr9hpPSfeHkCNvYSvM9FB';
const perPage = 9;

const state = {
  topReviews: []
}

const mutations = {
  ADD_TOP_REVIEWS (state, reviews) {
    state.topReviews = [...reviews.response.reviews];
  }
}

const actions = {
  topReviews ({ commit }) {
    if (fetching === false) {
      fetching = true;
      fetch(`https://api.yotpo.com/v1/widget/${apiKey}/products/yotpo_site_reviews/reviews.json?per_page=${perPage}&page=1`)
        .then((blob) => blob.json())
        .then(response => {
          commit('ADD_TOP_REVIEWS', parseDataForEditor(response))
        })
    }
  }
}

export default { namespaced: true, state, mutations, actions }
